import VProgressCircular from './VProgressCircular'

/* istanbul ignore next */
VProgressCircular.install = function install (Vue) {
  Vue.component(VProgressCircular.name, VProgressCircular)
}

export default VProgressCircular



// WEBPACK FOOTER //
// ./src/components/VProgressCircular/index.js